import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/download-completed'
import useLocalStorage from 'hooks/useLocalStorage'

const DownloadCompleted: React.FC = () => {
  const fromCorrectFormPage = useLocalStorage('refFlamingoDownloadPage')

  return (
    <>
      {fromCorrectFormPage && (
        <CustomHead
          keyword={'UX/UI モダナイゼーション SaaS 業務システム 変換サービス システム改修'}
          image={'https://www.i3design.jp/ogp_logo.png'}
          url={'https://www.i3design.jp/download/flamingo/done/'}
          title="UX/UIモダナイゼーションSaaS「flamingo」 | 資料ダウンロード | i3DESIGN アイスリーデザイン"
          description="システム改修なしでUX/UIを改善する「flamingo」の概要や機能、導入事例、料金について紹介した資料です。"
          noindexNofollow={true}
        />
      )}
      <Template />
    </>
  )
}

export default DownloadCompleted
